import { Card, Divider, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useBarChart } from '../hooks/useBarChart';
import { Loader } from './Loader';
import { AppBarChart } from './charts/BarChart';
import PropTypes from 'prop-types';

const ConcernCategoryBarChart = ({ concernData }) => {
  const { graphData, loading, setGraphData, setLoading, setYAxis, yAxis } =
    useBarChart();

  useEffect(() => {
    if (concernData) {
      setGraphData(concernData);

      const values = concernData.map((item) => Number(item.value));
      setYAxis({ min: Math.min(...values), max: Math.max(...values) });
      setLoading(false);
    }
  }, [concernData]);

  return (
    <Card
      variant="outlined"
      sx={{
        boxShadow: 3,
        width: '100%',
        height: '320px',
        p: '15px',
        background: '#1d2637',
        color: 'white',
        borderRadius: '12px',
        fontFamily: 'Montserrat, serif !important',
      }}
    >
      <Typography
        sx={{ fontFamily: 'Montserrat, serif !important' }}
        variant="overline"
        gutterBottom
      >
        Concern Category
      </Typography>
      <Divider />
      {loading ? (
        <Loader />
      ) : concernData.length === 0 ? (
        <Typography
          variant="body2"
          sx={{
            textAlign: 'center',
            color: 'white',
            mt: 2,
            fontFamily: 'Montserrat, serif !important',
          }}
        >
          No concerns recorded.
        </Typography>
      ) : (
        <AppBarChart
          data={graphData}
          xAxisKey={'reason'}
          xLabel={'Concern'}
          yLabel={'Count'}
          dataKey={'value'}
          yMax={yAxis.max}
          yMin={yAxis.min}
          fill="#e649fd"
          yMaxOffset={0}
          yMinOffset={0}
        />
      )}
    </Card>
  );
};

ConcernCategoryBarChart.propTypes = {
  concernData: PropTypes.array
}

export default ConcernCategoryBarChart;
